export default {
	addressTile: {
		deliveryNotificationPhone: "Lieferungsavisierung: {phone}",
		invoiceSentVia: "Rechnung wird per {method} versendet",
		invoiceMethodEmail: "E-Mail",
		invoiceMethodPost: "Post",
		applyAddressButton: "Übernehmen",
		preferredTooltipAlreadySet:
			"Diese Adresse ist bereits als Favorit markiert und wird bei Bestellungen für Sie vorgewählt.",
		preferredTooltipSetAsFavorite:
			"Als Favorit wählen. Diese Adresse wird bei Bestellungen für Sie vorgewählt.",
		editAddressTooltip: "Adresse bearbeiten",
		editPermissionMissingTooltip: "Berechtigung zum Bearbeiten der Adresse nicht vorhanden",
		deleteAddressTooltip: "Adresse löschen",
		deletePermissionMissingTooltip: "Berechtigung zum Löschen der Adresse nicht vorhanden",
		deleteAddressDialog: {
			title: "Adresse löschen",
			text: "Sind Sie sicher, dass Sie die Adresse löschen wollen?",
			deleteButtonTooltip: "Löscht die Adresse endgültig.",
			deleteButton: "Löschen",
		},
	},
	addressesOverview: {
		createAddressButton: "Neue Adresse erstellen",
	},
	changeAddress: {
		newAddressTitle: "Neue Adresse erstellen",
		editAddressTitle: "Adresse ändern",
		firstNameLabel: "Vorname",
		lastNameLabel: "Nachname",
		companyLabel: "Firma",
		streetLabel: "Strasse / Nr.",
		zipLabel: "PLZ",
		townLabel: "Ort",
		countryHint:
			"Das Land kann nicht geändert werden. Bitte kontaktieren Sie uns auf info@blexon.com",
		deliveryPhoneLabel: "Telefonnummer für Lieferungsavisierung",
		invoiceEmailLabel: "E-Mail Adresse für Rechnungsversand",
		invoiceByEmailLabel: "Rechnung per E-Mail",
		invoiceByPostLabel: "Rechnung per Post",
		shippingMethodLockedText:
			"Die Versandart kann für diese Bestellung nicht mehr verändert werden.",
		saveButtonTooltip: "Speichert die Änderungen.",
		invalidZipMessage: "Muss eine gültige PLZ sein.",
		messages: {
			saveSuccess: "Adresse erfolgreich gespeichert.",
			saveError: "Adresse konnte nicht gespeichert werden.",
		},
	},
	customerSettings: {
		customerNumberLabel: "Ihre Kundennummer",
		customerNumberHint: "Diese Nummer ist fest vergeben und kann nicht geändert werden.",
		personalAccountLabel: "Persönliches / privates Konto",
		companyNameLabel: "Firmenname",
		vatNumberLabel: "MwSt-Nummer / Umsatzsteuer-Id",
		useCompanyAccountLabel: "Als Firmenkonto verwenden",
		streetLabel: "Strasse / Nr.",
		zipLabel: "PLZ",
		townLabel: "Ort",
		countryLabel: "Land",
		generalPhoneLabel: "Telefon (allgemein)",
		accountEmailLabel: "Kundenkonto E-Mail",
		accountEmailHint: "Diese Adresse wird alternativ zur Benutzer-E-Mail verwendet.",
		defaultOrderNotificationEmailLabel:
			"Standard E-Mail für zusätzliche Auftragsbenachrichtigungen",
		defaultOrderNotificationEmailHint:
			"Im Bestellprozess kann eine zusätzliche E‑Mail‑Adresse angegeben werden, die ebenfalls über die Bestellung informiert wird. Wird im obigen Feld eine E‑Mail angegeben, so dient diese als Standard‑Adresse und wird automatisch abgefüllt.",
		correspondenceLanguageLabel: "Korrespondenzsprache",
		correspondenceLanguageHint:
			"In dieser Sprache werden sämtliche Dokumente wie Auftragsbestätigungen und Rechnungen sowie alle E‑Mails an Sie erstellt.",
		requiredMessage: "Angabe erforderlich",
		whitespaceOnlyMessage: "Eingabe darf nicht nur Leerzeichen sein.",
		maxLength50Message: "Maximal 50 Zeichen erlaubt.",
		companyNamePrivateMessage: "Firmenname darf nicht 'privat' sein.",
		invalidZipMessage: "Muss eine gültige PLZ sein.",
		messages: {
			saveSuccess: "Einstellungen erfolgreich gespeichert.",
			saveError: "Einstellungen konnten nicht gespeichert werden.",
		},
	},
	userManagement: {
		addUserButton: "Benutzer hinzufügen",
		emailChangeHint:
			"Hinweis: Um die E-Mail Adresse des aktuellen Benutzers zu ändern, verwenden Sie bitte die Funktion in den {userSettingsLink}.",
		userSettingsLinkText: "Benutzereinstellungen",
		pendingConfirmationTooltip: "Bestätigung des eingeladenen Benutzers noch ausstehend.",
		contextMenuTooltip: "Öffnet das Kontextmenü zum Benutzer.",
		deleteMenuItem: "Löschen",
		manageUsersLabel: "Benutzer verwalten",
		orderDirectlyLabel: "Bestellen",
		orderIndirectlyLabel: "Bestellung beantragen",
		changeDeliveryAddressLabel: "Lieferadressen ändern",
		changeInvoiceAddressLabel: "Rechnungsadressen ändern",
		ownUserRightsTooltip: "Die Rechte des eigenen Benutzers können nicht angepasst werden.",
		unconfirmedUserRightsTooltip:
			"Die Rechte können erst angepasst werden, wenn der Benutzer bestätigt ist.",
		manageUsersMinimumTooltip: 'Es muss stets 1 Benutzer das Recht "Benutzer verwalten" haben.',
		manageUsersDescriptionTooltip:
			"Der Benutzer kann weitere Benutzer hinzufügen, Benutzer löschen und die Rechte aller Benutzer bearbeiten.",
		orderDirectlyMinimumTooltip: 'Es muss stets 1 Benutzer das Recht "Bestellen" haben.',
		orderDirectlyDescriptionTooltip: "Der Benutzer kann zahlungspflichtig bestellen.",
		orderIndirectlyDescriptionTooltip:
			"Der Benutzer kann Bestellungen vorbereiten und zur Bestätigung an Benutzer mit der entsprechenden Berechtigung senden.",
		changeDeliveryAddressDescriptionTooltip: "Der Benutzer kann die Lieferadressen ändern.",
		changeInvoiceAddressDescriptionTooltip: "Der Benutzer kann die Rechnungsadressen ändern.",
		noPermissionText: "Berechtigung zur Benutzerverwaltung nicht vorhanden.",
		addUserDialogTitle: "Benutzer hinzufügen",
		newUserEmailPlaceholder: "Email des neuen Benutzers",
		newUserRightsLabel: "Rechte des neuen Benutzers",
		addButton: "Hinzufügen",
		deleteUserDialog: {
			title: "Sind Sie sicher?",
			text: "Soll der Benutzer {username} wirklich aus dem Konto entfernt werden?",
			confirmButton: "Entfernen",
		},
		messages: {
			loadUserIdError: "Fehler beim Laden der Benutzer-Id.",
			loadUsersError: "Fehler beim Laden der Benutzer.",
			saveClaimSuccess: "Berechtigung erfolgreich gespeichert.",
			saveClaimError: "Fehler beim Speichern der Berechtigung.",
			inviteSuccess: "Einladung erfolgreich an Benutzer gesendet.",
			inviteError: "Fehler beim versenden der Einladung an den Benutzer.",
			removeUserError: "Fehler beim Löschen des Benutzers.",
		},
	},
};
